import { styled, keyframes } from 'styled-components';
const loaderAnimation = keyframes `
  to {
    transform:translateX(100%)
  }
`;
export const LoaderBar = styled.span `
  width: 100%;
  height: 20px;
  min-width: 28px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.grey05_1};

  &:after {
    animation: ${loaderAnimation} 1.5s infinite;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);
    z-index: 1;
    background: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, 0.3), transparent);
    animation-delay: 0.1s;
  }
`;
